var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcEdit16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.98 10.476a1 1 0 0 1 .252-.421l6.25-6.25 3.713 3.713-6.25 6.25a1 1 0 0 1-.42.252l-3.133.934a1.082 1.082 0 0 1-1.345-1.346zM9.261 3.026l1.256-1.256c2.194-2.194 5.947 1.48 3.714 3.714L12.975 6.74z"
})));
export default SvgIcEdit16;